import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconPulse: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M18.3334 9H15.0001L12.5001 16.5L7.50008 1.5L5.00008 9H1.66675"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="butt"
        strokeLinejoin="bevel"
        fillOpacity="0"
        fill={fill}
      />
    </Icon>
  );
};

export default IconPulse;
